"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCalendarIntegration = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../store/personalIntegration/personalIntegration.selector"));

var actions = _interopRequireWildcard(require("../store/personalIntegration/personalIntegration.actions"));

var useCalendarIntegration = function useCalendarIntegration() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoading = (0, _reactRedux.useSelector)(selectors.integrationsIsLoading);
  var isLoaded = (0, _reactRedux.useSelector)(selectors.isActiveServiceLoaded);
  var currentIntegration = (0, _reactRedux.useSelector)(selectors.activeIntegration);
  (0, _react.useEffect)(function () {
    if (!isLoaded) {
      dispatch(actions.getActiveIntegration());
    }
  }, [dispatch, isLoaded]);
  return {
    currentIntegration,
    isLoading
  };
};

exports.useCalendarIntegration = useCalendarIntegration;